var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnMusicOff = function SvgBtnMusicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15Zm0 1c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
    fill: "#DDDEE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.036 13.18 1.414 1.143 2.72-.816v3.013l1.5 1.212v-6.797a1.933 1.933 0 0 0-2.489-1.852l-5.522 1.656c-.149.045-.29.107-.42.183l1.363 1.1 5.01-1.502a.433.433 0 0 1 .558.415v1.006l-4.134 1.24ZM20.769 20.93l-1.236-.999a.867.867 0 0 1-1.138-.919l-1.236-.999a2.366 2.366 0 0 0 3.61 2.916Z",
    fill: "#A4A7AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.906 15.386-1.624-1.312v3.853a2.366 2.366 0 1 0 1.447 2.316h.053v-4.82l.124-.037Zm-1.673 4.724a.866.866 0 1 1-1.733 0 .866.866 0 0 1 1.733 0ZM23.714 21.346c-.241.347-.693.421-1.009.166L9.942 11.202c-.315-.254-.375-.742-.133-1.089.241-.347.693-.421 1.008-.166l12.763 10.31c.316.254.376.742.134 1.089Z",
    fill: "#A4A7AD"
  })));
};
export default SvgBtnMusicOff;